export const BASE_URL = "https://api.kycaml.systems/mainapp-staging/api/";
export const AUTH_URL = "https://api.kycaml.systems/mainapp-staging/auth/api/"
export const S3_BUCKET_NAME = "videosss";
export const MAIN_APP_URL = "https://ahrvoid.com/";
export const CDN_URL = "https://d1rfo5pw240a8w.cloudfront.net/";
export const BIOMETRIC_BACKEND_URL =
  "https://api.kycaml.systems/backend-staging/api/";
export const DEEPFACE_BACKEND_URL =
  "https://api.kycaml.systems/backend-staging/api/";
export const TRUSTLY_CDN_URL =
  "https://cdn1.sandbox.paywithmybank.com/start/assets/institutions/";

export const initData = {
  showBusinessByDefault: false,
  apikey: "",
  isExpiryRequired: true,
  isWalletRequired: false,
  showCompanyApplicantType: false,
  client_webapp_url: "https://ahrvoid.com",
  nftid: "",
  showPaymentFields: false,
  kycType: "kycwithliveness",
  env: "MAINAPP",
  company_id: "",
  apiUrl: BASE_URL,
  showOpenBankingDiv: false,
};
export const CURRENTENVIROMENT = "staging";
export const ENVIROMENT = {
  STAGING: "staging",
  PRODUCTION: "production",
};
export const VIDEO_UPLOAD_TOKEN="7XH4-P8>~d#~!e2wj9QJ8P15M,M=e"
export const VIDEO_UPLOAD_URL="https://kittzehjucrpczdx2lrc7gom7y0rkjoo.lambda-url.us-east-2.on.aws/"